var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './MessageBoxFunctionalLayout.scss';
import HeaderLayout from './HeaderLayout';
import FooterLayout from './FooterLayout';
import WixComponent from '../BaseComponents/WixComponent';

var MessageBoxFunctionalLayout = function (_WixComponent) {
  _inherits(MessageBoxFunctionalLayout, _WixComponent);

  function MessageBoxFunctionalLayout() {
    _classCallCheck(this, MessageBoxFunctionalLayout);

    return _possibleConstructorReturn(this, (MessageBoxFunctionalLayout.__proto__ || Object.getPrototypeOf(MessageBoxFunctionalLayout)).apply(this, arguments));
  }

  _createClass(MessageBoxFunctionalLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          onCancel = _props.onCancel,
          onOk = _props.onOk,
          onClose = _props.onClose,
          confirmText = _props.confirmText,
          cancelText = _props.cancelText,
          children = _props.children,
          buttonsHeight = _props.buttonsHeight,
          hideFooter = _props.hideFooter,
          theme = _props.theme,
          closeButton = _props.closeButton,
          disableConfirmation = _props.disableConfirmation,
          disableCancel = _props.disableCancel,
          width = _props.width;


      return React.createElement(
        'div',
        { className: styles.content, style: { width: width } },
        React.createElement(HeaderLayout, { title: title, onCancel: onClose ? onClose : onCancel, theme: theme, closeButton: closeButton }),
        React.createElement(
          'div',
          { className: styles.body },
          children
        ),
        !hideFooter ? React.createElement(FooterLayout, { enableCancel: !disableCancel, enableOk: !disableConfirmation, buttonsHeight: buttonsHeight, confirmText: confirmText, cancelText: cancelText, onCancel: onCancel, onOk: onOk, theme: theme }) : null
      );
    }
  }]);

  return MessageBoxFunctionalLayout;
}(WixComponent);

MessageBoxFunctionalLayout.propTypes = {
  hideFooter: PropTypes.bool,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  theme: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  width: PropTypes.string,
  title: PropTypes.node,
  children: PropTypes.any,
  buttonsHeight: PropTypes.string,
  closeButton: PropTypes.bool,
  disableCancel: PropTypes.bool,
  disableConfirmation: PropTypes.bool
};

MessageBoxFunctionalLayout.defaultProps = {
  buttonsHeight: 'small',
  disableCancel: false,
  disableConfirmation: false,
  width: '600px'
};

export default MessageBoxFunctionalLayout;
//# sourceMappingURL=MessageBoxFunctionalLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MessageBox/MessageBoxFunctionalLayout.js